export const locale = {
  "sr-RS": {
    "accept": "Prihvati",
    "addRule": "Dodaj pravilo",
    "am": "AM",
    "apply": "Primeni",
    "cancel": "Otkaži",
    "choose": "Izaberi",
    "chooseDate": "Izaberi datum",
    "chooseMonth": "Izaberi mesec",
    "chooseYear": "Izaberi godinu",
    "clear": "Očisti",
    "completed": "Završeno",
    "contains": "Sadrži",
    "custom": "Prilagođeno",
    "dateAfter": "Datum je posle",
    "dateBefore": "Datum je pre",
    "dateFormat": "dd.mm.yy.",
    "dateIs": "Datum je",
    "dateIsNot": "Datum nije",
    "dayNames": [
      "Nedelja",
      "Ponedeljak",
      "Utorak",
      "Sreda",
      "Četvrtak",
      "Petak",
      "Subota"
    ],
    "dayNamesMin": [
      "Ne",
      "Po",
      "Ut",
      "Sr",
      "Če",
      "Pe",
      "Su"
    ],
    "dayNamesShort": [
      "Ned",
      "Pon",
      "Uto",
      "Sre",
      "Čet",
      "Pet",
      "Sub"
    ],
    "emptyFilterMessage": "Nema pronađenih rezultata",
    "emptyMessage": "Nema dostupnih opcija",
    "emptySearchMessage": "Nema pronađenih rezultata",
    "emptySelectionMessage": "Nema odabranih stavki",
    "endsWith": "Završava sa",
    "equals": "Jednako",
    "fileChosenMessage": "{0} fajlova",
    "fileSizeTypes": [
      "B",
      "KB",
      "MB",
      "GB",
      "TB",
      "PB",
      "EB",
      "ZB",
      "YB"
    ],
    "filter": "Filter",
    "firstDayOfWeek": 1,
    "gt": "Veće od",
    "gte": "Veće ili jednako",
    "lt": "Manje od",
    "lte": "Manje ili jednako",
    "matchAll": "Podudaraju se svi",
    "matchAny": "Podudaraju se bilo koji",
    "medium": "Srednje",
    "monthNames": [
      "Januar",
      "Februar",
      "Mart",
      "April",
      "Maj",
      "Jun",
      "Jul",
      "Avgust",
      "Septembar",
      "Oktobar",
      "Novembar",
      "Decembar"
    ],
    "monthNamesShort": [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "Maj",
      "Jun",
      "Jul",
      "Avg",
      "Sep",
      "Okt",
      "Nov",
      "Dec"
    ],
    "nextDecade": "Naredna decenija",
    "nextHour": "Naredni sat",
    "nextMinute": "Naredni minut",
    "nextMonth": "Naredni mesec",
    "nextSecond": "Naredna sekunda",
    "nextYear": "Naredna godina",
    "noFileChosenMessage": "Nije izabrana nijedna datoteka",
    "noFilter": "Bez filtera",
    "notContains": "Ne sadrži",
    "notEquals": "Nije jednako",
    "now": "Sada",
    "passwordPrompt": "Unesite lozinku",
    "pending": "Na čekanju",
    "pm": "PM",
    "prevDecade": "Prethodna decenija",
    "prevHour": "Prethodni sat",
    "prevMinute": "Prethodni minut",
    "prevMonth": "Prethodni mesec",
    "prevSecond": "Prethodna sekunda",
    "prevYear": "Prethodna godina",
    "reject": "Odbaci",
    "removeRule": "Ukloni pravilo",
    "searchMessage": "Dostupno rezultata: {0}",
    "selectionMessage": "Odabrano stavki: {0}",
    "showMonthAfterYear": false,
    "startsWith": "Počinje sa",
    "strong": "Jako",
    "today": "Danas",
    "upload": "Postavi",
    "weak": "Slabo",
    "weekHeader": "Sed",
    "aria": {
      "cancelEdit": "Otkaži izmene",
      "close": "Zatvori",
      "collapseLabel": "Sklopi",
      "collapseRow": "Sklopi red",
      "editRow": "Izmeni red",
      "expandLabel": "Proširi",
      "expandRow": "Proširi red",
      "falseLabel": "Nije tačno",
      "filterConstraint": "Ograničenje filtera",
      "filterOperator": "Operator filtera",
      "firstPageLabel": "Prva strana",
      "gridView": "Prikaz u tabeli",
      "hideFilterMenu": "Sakri meni filtera",
      "jumpToPageDropdownLabel": "Skok na stranu (padajući meni)",
      "jumpToPageInputLabel": "Skok na stranu (unos)",
      "lastPageLabel": "Poslednja strana",
      "listLabel": "Lista opcija",
      "listView": "Prikaz u listi",
      "maximizeLabel": "Maksimiziraj",
      "minimizeLabel": "Minimiziraj",
      "moveAllToSource": "Pomakni sve na izvor",
      "moveAllToTarget": "Pomakni sve na cilj",
      "moveBottom": "Pomakni na dno",
      "moveDown": "Pomakni dole",
      "moveTop": "Pomakni na vrh",
      "moveToSource": "Pomakni na izvor",
      "moveToTarget": "Pomakni na cilj",
      "moveUp": "Pomakni gore",
      "navigation": "Navigacija",
      "next": "Sledeće",
      "nextPageLabel": "Sledeća strana",
      "nullLabel": "Nije odabrano",
      "otpLabel": "Unesite jednokratnu lozinku {0}",
      "pageLabel": "Strana {page}",
      "passwordHide": "Sakri lozinku",
      "passwordShow": "Prikaži lozinku",
      "previous": "Prethodno",
      "prevPageLabel": "Prethodna strana",
      "removeLabel": "Ukloni",
      "rotateLeft": "Rotiraj levo",
      "rotateRight": "Rotiraj desno",
      "rowsPerPageLabel": "Redova po strani",
      "saveEdit": "Sačuvaj izmene",
      "scrollTop": "Skrol na vrh",
      "selectAll": "Odabrane su sve stavke",
      "selectColor": "Izaberite boju",
      "selectLabel": "Odaberi",
      "selectRow": "Red odabran",
      "showFilterMenu": "Prikaži filter meni",
      "slide": "Slajd",
      "slideNumber": "Slajd {slideNumber}",
      "star": "1 Zvezda",
      "stars": "Zvezda: {start}",
      "trueLabel": "Tačno",
      "unselectAll": "Poništen je odabir svih stavki",
      "unselectLabel": "Poništi odabir",
      "unselectRow": "Red nije odabran",
      "zoomImage": "Zumiraj sliku",
      "zoomIn": "Uvećaj",
      "zoomOut": "Smanji"
    }
  }
}